import { LandingSection } from '@features/landing/shared/ui/components/LandingSection';
import styles from './ActionsSection.module.css';
import { LandingButton } from '@features/landing/shared/ui/components/LandingButton';
import {
  LINK_TELEGRAM_CHANNEL,
  LINK_TOURNAMENTS,
} from '@features/chessrussian/customizations/constants';
import { usePremiumLinksCtx } from '@features/landing/shared/providers/PremiumLinksProvider';

export function ActionsSection() {
  const ctx = usePremiumLinksCtx();
  return (
    <LandingSection className={styles.root}>
      <div className={styles.content}>
        <LandingButton
          color="active-light"
          size="48l-59"
          href={LINK_TOURNAMENTS}
        >
          Выбрать турнир в&nbsp;клубе&nbsp;РШШ&nbsp;›
        </LandingButton>

        <LandingButton color="active-light" size="48l-59" href={ctx.bothLink}>
          <span>
            Купить <span className={styles.nowrap}>премиум-аккаунт</span>&nbsp;›
          </span>
        </LandingButton>

        <LandingButton
          color="active-light"
          size="48l-59"
          href={LINK_TELEGRAM_CHANNEL}
        >
          Телеграм-канал&nbsp;›
        </LandingButton>

        <LandingButton
          color="active-light"
          size="48l-59"
          href="tel:+7495-118-23-06"
        >
          +7 495 118 23 06
        </LandingButton>
      </div>
    </LandingSection>
  );
}
